import Utils from "../utils/Utils";

export const TRANSLATION_SOURCES = {
  common: "COMMON_PLATFORM",
  web: "WEB_CLIENT_APPLICATION",
  admin: "ADMIN_PORTAL_CLIENT_APPLICATION",
};

export async function getLabels(language, source) {
  if (!Object.prototype.hasOwnProperty.call(TRANSLATION_SOURCES, source)) {
    throw new Error("Unknown translation source.");
  }
  const query = new URLSearchParams({
    language,
    sourceApplication: "ADMIN_PORTAL_CLIENT_APPLICATION",
  });
  const response = await Utils.controller(
    "api/translation/v1/label",
    "",
    "GET",
    query.toString(),
    false,
    undefined,
    true,
  );
  if (response?.status !== 200 || !Array.isArray(response.data)) {
    throw new Error("Could not load translations.");
  }
  return Object.fromEntries(
    response.data
      .filter(
        (label) =>
          typeof label?.labelID === "string" &&
          typeof label.labelTranslation === "string" &&
          label.labelTranslation.trim(),
      )
      .map((label) => [label.labelID, label.labelTranslation]),
  );
}
